// © Microsoft Corporation. All rights reserved.
/**
 * The start suffix for perf markings.
 */
export const perfMarkerStartSuffix = "-start";
/**
 * The end suffix for perf markings.
 */
export const perfMarkerEndSuffix = "-end";
/**
 * The perf marking name for crs initial merged config fetch.
 */
export const perfMarkerCrsConfigName = "CrsConfig";
//# sourceMappingURL=PerfMarkerConstants.js.map